import { render, staticRenderFns } from "./Pile.vue?vue&type=template&id=bc654308&scoped=true"
import script from "./Pile.vue?vue&type=script&lang=js"
export * from "./Pile.vue?vue&type=script&lang=js"
import style0 from "./Pile.vue?vue&type=style&index=0&id=bc654308&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc654308",
  null
  
)

export default component.exports